import { render } from "./FooterLogos.vue?vue&type=template&id=56f41bf3&scoped=true&ts=true"
import script from "./FooterLogos.vue?vue&type=script&lang=ts"
export * from "./FooterLogos.vue?vue&type=script&lang=ts"

import "./FooterLogos.vue?vue&type=style&index=0&id=56f41bf3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f41bf3"]])

export default __exports__